<div class="mt-4 p-5 card">
  <div class="row card-title">
    <div class="col-md-12">
      <div class="row justify-content-between align-items-center">

        <!-- Título -->
        <div class="col-md-6">
          <h4 class="text-lg-start">Minhas tarefas</h4>
        </div>

        <!-- Navegação de dias -->
        <div *ngIf="!telaPequena" class="col-md-6 text-end">
          <button class="btn btn-outline-primary btn-sm me-2" (click)="semanaAnterior()">
            <i class="fa fa-chevron-left"></i>
          </button>
          <button
            class="btn btn-sm me-2"
            [ngClass]="{
                'btn-outline-secondary': ehHoje(diaSelecionado),
                'btn-outline-primary': !ehHoje(diaSelecionado)
              }"
            (click)="voltarHoje()"
          >
            Hoje
          </button>
          <button class="btn btn-outline-primary btn-sm me-3" (click)="proximaSemana()">
            <i class="fa fa-chevron-right"></i>
          </button>
          <span class="fw-bold">Semana de {{ semana[0].data | date:'dd/MM' }} a {{ semana[4].data | date:'dd/MM' }}</span>
        </div>

      </div>

      <!-- Dias da semana -->
      <div class="row mt-3">
        <div class="d-flex justify-content-between text-center">
          <div
            *ngFor="let dia of semana"
            class="flex-fill p-2 rounded dia-da-semana"
            [ngClass]="{ 'hoje': ehHoje(dia.data), 'ativo': ehSelecionado(dia.data) }"
            (click)="selecionarDia(dia.data)">

            <div class="fw-bold">{{ dia.nome }}</div>
            <div>{{ dia.data | date: 'dd/MM' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Timeline -->
  <div class="timeline-dia calendario-container mt-4">
    <div *ngFor="let hora of horas">
      <div class="hora-label">{{ hora }}</div>
    </div>

    <div *ngFor="let event of events" class="event-block" [ngStyle]="getEventStyle(event)">
      {{ event.title }}<br />
      {{ event.start }} - {{ event.end }}
    </div>

    <div class="current-time-line" [style.top.px]="currentTimeTop"></div>
  </div>
</div>
